import script from "./WorkspacesListCell.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspacesListCell.vue?vue&type=script&setup=true&lang=js"

import "./WorkspacesListCell.vue?vue&type=style&index=0&id=37a82c89&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a82c89"]])

export default __exports__